export default {
    key: 'our-consultants',
    label: 'Our consultants',
    component: {
        name: 'OurConsultantsTemplate',
        loader: () => import('./OurConsultantsTemplate')
    },
    modules: {
        locations: [
            {
                label: 'Primary modules',
                name: 'primary'
            },
            {
                label: 'Secondary modules',
                name: 'secondary'
            }
        ]
    }
};
